import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/pages/Home';
import Aonaer from '@/pages/Home/Aonaer';
import User from '@/pages/User';
import UserInfo from '@/pages/User/Info';
import UserShop from '@/pages/User/Shop';
import UserRecord from '@/pages/User/Record';
import UserPRecord from '@/pages/User/PRecord';
import UserSign from '@/pages/Sign';
import UserHome from '@/pages/User/Home';
import News from '@/pages/News';
import NewsInfo from '@/pages/News/Info';
import HaiBao from '@/pages/Poster';
import HBDetail from '@/pages/Poster/Detail';
import Admin from '@/pages/Admin';
import AdminUser from '@/pages/Admin/User';
import AdminStaff from '@/pages/Admin/User/Staff';
import AdminRole from '@/pages/Admin/User/Role';
import AdminMenu from '@/pages/Admin/User/Menu';
import AdminNews from '@/pages/Admin/System';
import AdminVideo from '@/pages/Admin/System/Video';
import AdminVideoType from '@/pages/Admin/System/Video/Type';
import AdminPoster from '@/pages/Admin/System/Poster';
import AdminPosterType from '@/pages/Admin/System/Poster/Type';
import AdminUserDepart from '@/pages/Admin/User/Depart';
import AdminPoints from '@/pages/Admin/User/Points';
import AdminPointsRecord from '@/pages/Admin/User/Points/Record';
import AdminProduct from '@/pages/Admin/Product';
import AdminOrder from '@/pages/Admin/Product/Order';
import Video from '@/pages/Video';
import Poster from '@/pages/Book';
import Threejs from '@/pages/Threejs';
import OneStop from '@/pages/One';
import Fis from '@/pages/Fis';
import List from '@/pages/List';
Vue.use(VueRouter);
export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        // {
        //     name: '首页',
        //     path: '/',
        //     component: Home,
        //     meta: {
        //         metaInfo: {
        //             title: '综合信息系统-首页',
        //             keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
        //             description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
        //         }
        //     }
        // },
        {
            name: '奥纳尔首页',
            path: 'aonaer',
            component: Aonaer,
            meta: {
                metaInfo: {
                    title: '综合信息系统-奥纳尔首页',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '订单核销',
            path: '/sign/:id',
            component: UserSign,
            meta: {
                metaInfo: {
                    title: '综合信息系统-订单核销',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '积分榜单',
            path: '/list/:year/:month',
            component: List,
            meta: {
                metaInfo: {
                    title: '综合信息系统-积分榜单',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '个人中心',
            path: '/user',
            component: User,
            redirect: '/user/info',
            meta: {
                metaInfo: {
                    title: '综合信息系统-个人中心',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            },
            children: [
                {
                    name: '个人信息',
                    path: 'info',
                    component: UserInfo,
                    meta: {
                        metaInfo: {
                            title: '综合信息系统-个人信息',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '积分商城',
                    path: 'shop',
                    component: UserShop,
                    meta: {
                        metaInfo: {
                            title: '综合信息系统-积分商城',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '兑换记录',
                    path: 'record',
                    component: UserRecord,
                    meta: {
                        metaInfo: {
                            title: '综合信息系统-兑换记录',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '积分记录',
                    path: 'precord',
                    component: UserPRecord,
                    meta: {
                        metaInfo: {
                            title: '综合信息系统-积分记录',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '系统首页',
                    path: 'home',
                    component: UserHome,
                    meta: {
                        metaInfo: {
                            title: '综合信息系统-用户主页',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                }
            ]
        },
        {
            name: '集团新闻',
            path: '/news/:id',
            component: News,
            meta: {
                metaInfo: {
                    title: '综合信息系统-集团新闻',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            },
            // children: [
            //     {
            //         name: '新闻内容',
            //         path: 'info/:id',
            //         component: NewsInfo,
            //         meta: {
            //             metaInfo: {
            //                 title: '邦邦工厂-后台首页',
            //                 keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
            //                 description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
            //             }
            //         }
            //     },
            // ]
        },
        {
            name: '新闻内容',
            path: '/news_info/:id',
            component: NewsInfo,
            meta: {
                metaInfo: {
                    title: '综合信息系统-新闻内容',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '公司海报',
            path: '/haibao/:year',
            component: HaiBao,
            meta: {
                metaInfo: {
                    title: '综合信息系统-公司海报',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '万市德',
            path: '/onestop',
            component: OneStop,
            meta: {
                metaInfo: {
                    title: '综合信息系统-万市德',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '飞斯智能',
            path: '/fis',
            component: Fis,
            meta: {
                metaInfo: {
                    title: '综合信息系统-飞斯智能',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '公司画册',
            path: '/book',
            component: Poster,
            meta: {
                metaInfo: {
                    title: '综合信息系统-公司画册',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '工厂模型',
            path: '/moxing',
            component: Threejs,
            meta: {
                metaInfo: {
                    title: '综合信息系统-工厂模型',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '海报详情',
            path: '/hb_detail/:id',
            component: HBDetail,
            meta: {
                metaInfo: {
                    title: '综合信息系统-海报详情',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '公司视频',
            path: '/video',
            component: Video,
            meta: {
                metaInfo: {
                    title: '综合信息系统-公司视频',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '后台管理',
            path: '/admin',
            component: Admin,
            redirect: '/admin/user',
            meta: {
                metaInfo: {
                    title: '综合信息管理-后台管理',
                    keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            },
            children: [
                {
                    name: '用户管理',
                    path: 'user',
                    component: AdminUser,
                    meta: {
                        metaInfo: {
                            title: '综合信息管理-员工管理',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '员工管理',
                    path: 'staff',
                    component: AdminStaff,
                    meta: {
                        metaInfo: {
                            title: '综合信息管理-员工管理',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '角色管理',
                    path: 'role',
                    component: AdminRole,
                    meta: {
                        metaInfo: {
                            title: '综合信息管理-角色管理',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '菜单管理',
                    path: 'menu',
                    component: AdminMenu,
                    meta: {
                        metaInfo: {
                            title: '综合信息管理-菜单管理',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '新闻管理',
                    path: 'news',
                    component: AdminNews,
                    meta: {
                        metaInfo: {
                            title: '综合信息管理-新闻管理',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '视频分类管理',
                    path: 'videotype',
                    component: AdminVideoType,
                    meta: {
                        metaInfo: {
                            title: '综合信息管理-视频管理',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '视频管理',
                    path: 'video',
                    component: AdminVideo,
                    meta: {
                        metaInfo: {
                            title: '综合信息管理-视频管理',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '海报管理',
                    path: 'poster',
                    component: AdminPoster,
                    meta: {
                        metaInfo: {
                            title: '综合信息管理-海报管理',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '海报分类管理',
                    path: 'postertype',
                    component: AdminPosterType,
                    meta: {
                        metaInfo: {
                            title: '综合信息管理-海报分类管理',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '积分管理',
                    path: 'points',
                    component: AdminPoints,
                    meta: {
                        metaInfo: {
                            title: '综合信息管理-积分管理',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '积分记录',
                    path: 'record/:id',
                    component: AdminPointsRecord,
                    meta: {
                        metaInfo: {
                            title: '综合信息管理-积分记录',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '商品管理',
                    path: 'product',
                    component: AdminProduct,
                    meta: {
                        metaInfo: {
                            title: '综合信息管理-商品管理',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '订单管理',
                    path: 'order',
                    component: AdminOrder,
                    meta: {
                        metaInfo: {
                            title: '综合信息管理-订单管理',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '部门管理',
                    path: 'depart',
                    component: AdminUserDepart,
                    meta: {
                        metaInfo: {
                            title: '综合信息管理-部门管理',
                            keywords: '卡提货, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                }
            ]
        },
        {
            path: '*',
            redirect: '/user/home'

        }
    ]
});